import { useState, useEffect } from 'react';
import { Button } from 'antd';
import { Edit } from '../Svg/Svg';
import Markdown from 'markdown-to-jsx';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import LocalLoader from '../LocalLoader';

export default function TextEditor({
    data,
    flag,
    onSave,
    onChange,
    isDataLoading,
    currentPage,
    title,
    initialData,
}) {
    const [view, setView] = useState('view');

    useEffect(() => {
        setView('view');
    }, [flag]);

    const onEditClick = () => {
        setView('edit');
    };

    const onCancelButtonClick = () => {
        onChange(initialData?.[flag]?.[currentPage], flag);
        setView('view');
    };

    const onEditorChange = (event, editor) => {
        const data = editor.getData();
        onChange(data, flag);
    };

    const onDataSave = async () => {
        await onSave();
        setView('view');
    };

    return (
        <div className="details-table-wrapper">
            <div className="table-top-pannel">
                <div className="table-top-pannel__info">
                    <h2 className="table-top-pannel__title">{title}</h2>
                </div>
                {view === 'view' && (
                    <Button type="primary" size="large" onClick={onEditClick}>
                        <Edit />
                        <span style={{ marginLeft: '8px' }}>Edit</span>
                    </Button>
                )}
                {view === 'edit' && (
                    <div className="details-table__buttons-wrapper">
                        <button
                            className="details-table__button modal__button-cancel"
                            onClick={onCancelButtonClick}
                        >
                            Cancel
                        </button>
                        <button
                            className="details-table__button modal__button-accept"
                            type="submit"
                            form="edit-client-form"
                            onClick={onDataSave}
                        >
                            Save
                        </button>
                    </div>
                )}
            </div>
            {view === 'view' && (
                <div className="markdown-wrapper">
                    <LocalLoader isLoading={isDataLoading}>
                        <Markdown>
                            {data.policies[flag][currentPage] ||
                                'Add some description here...'}
                        </Markdown>
                    </LocalLoader>
                </div>
            )}
            {view === 'edit' && (
                <div>
                    <CKEditor
                        editor={Editor}
                        id={`editor_${flag}`}
                        config={{
                            toolbar: {
                                items: [
                                    'undo',
                                    'redo',
                                    'heading',
                                    'bold',
                                    'italic',
                                    'link',
                                    'bulletedList',
                                    'numberedList',
                                    'insertTable',
                                    'outdent',
                                    'indent',
                                    'blockQuote',
                                    'htmlEmbed',
                                ],
                            },
                        }}
                        data={data.policies[flag][currentPage]}
                        onChange={onEditorChange}
                        onReady={(editor) => {
                            if (!editor) return;
                            editor.focus();
                        }}
                    />
                </div>
            )}
        </div>
    );
}
